
export type Fertilizer = {
    id: number;
    name: string;
    percent_N: number;
    lbs_N_per_gallon: number;
    density: number;
    fertilizer_type: FertilizerType;
    created_by: number;
    last_modified_by: number;
  };
  
  export enum FertilizerType {
    dry = 1,
    liquid = 2,
  }